/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Confirmation from './Confirmation/index'
import React from 'react'
import TrashIcon from 'DesignSystem/Svgs/TrashIcon/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/VideoFile/FrameGrabs/Content/Images/TemporaryImage/DeleteAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 size="small"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TrashIcon
{...childProps}
  viewPath={`${viewPath}/TrashIcon`}
 fill="white"
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
{children}
</React.Fragment>)
}